<template>
  <div class="view-all-shortlists">
    <loader :loading="loading"></loader>
    <div class="shortlist-menu">
      <div class="close-btn">
        <button
          type="button"
          class="circled interactive grey close-modal outline"
          @click.stop.prevent="closeMenu"
        >
          <svg-icon id="cross"></svg-icon>
        </button>
      </div>
      <div class="heading">Add to shortlist</div>
      <div v-for="shortlist in shortlists" :key="shortlist.slug" class="shortlist-menu-container">
        <div class="shortlist-menu-label">{{ shortlist.label }}</div>
        <div
          class="shortlist-menu-btn"
          :class="{ active: isActive(shortlist) }"
          @click="toggle(shortlist)">
            <div v-if="isActive(shortlist)" class="shortlist-menu-btn-label">Remove <div class="icon-minus">
              <svg xmlns="http://www.w3.org/2000/svg">
                <image xlink:href="/images/icons/trash-light.svg" />
              </svg>
            </div></div>
            <div v-else class="shortlist-menu-btn-label">
              Add
              <svg xmlns="http://www.w3.org/2000/svg">
                <image xlink:href="/images/icons/add.svg" />
              </svg>
            </div>
        </div>
      </div>
    </div>
    <div class="shortlist-create-new" @click="addNewShortlist">
      <div class="shortlist-create-new-label">Create New Shortlist</div>
    </div>
  </div>
</template>

<script>
import BaseModal from '../Base'

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    closeMenu() {
      this.$emit('cancel');
    },
    addNewShortlist() {
      this.$store
        .dispatch("modals/show", {
          title: "Create a new shortlist",
          type: "shortlist-add",
          maskCanDismiss: false,
          narrow: true,
        })
        .then((result) => {
          this.toggle(result.related.shortlist);
          this.$eventBus.$emit("updateShortlists");
        })
        .catch(() => {});
        this.closeMenu();
    },
    isActive(shortlist) {
      if (this.data.listing) {
        for (let listing of shortlist.listings) {
          if (listing.id == this.data.listing.id) {
            return true;
          }
        }
      } else if (this.data.selected) {
        for (let selectedListing of this.data.selected) {
          let found = false;

          for (let listing of shortlist.listings) {
            if (selectedListing.id == listing.id) {
              found = true;
            }
          }

          if (!found) {
            return false;
          }
        }

        return true;
      }

      return false;
    },
    toggle(shortlist) {
      if(this.loading) {
        return;
      }
      if (this.data.listing || this.data.selected) {
        let listings = [];

        if (this.data.listing) {
          listings.push({
            id: this.data.listing.id,
            name: this.data.listing.space_name,
            media: this.data.listing.preferred_thumbnail
              ? this.data.listing.preferred_thumbnail.id
              : null,
          });
        } else {
          listings = this.data.selected;
        }

        let make_active = !this.isActive(shortlist);
        this.loading = true;

        this.$store
          .dispatch("user/toggleShortlistProperties", {
            shortlistId: shortlist.id,
            listings: listings,
            shortlisted: make_active,
          })
          .then(() => {
            // Track the search
            for (let listing of listings) {
              console.info(listing);

              this.$store.dispatch("intercom/track", {
                type: make_active
                  ? "Shortlist Property"
                  : "Unshortlist Property",
                meta: {
                  shortlistId: shortlist.id,
                  listingId: listing.id,
                  name: listing.name,
                },
              });
            }
            this.loading = false;
          })
          .catch((e) => {
            this.$toasted.show(
              "Your shortlists could not be updated, please reload the page and try again.",
              { type: "error" }
            );
            this.loading = false;
          });
      }
    },
  },
  computed: {
    shortlists() {
      return this.$store.getters["user/shortlists"].sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
    },
  }
}
</script>
